module.exports = __webpack_public_path__ + "static/media/illustrator.8a8d2074.svg";